export default "__VITE_ASSET__BRHH4V7H__"